import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const initialState = () => ({
  liveResultToggles: {
    showNames: true,
    showResponses: true,
    showResults: true,
  },
});

export type resultsGridSliceState = {
  liveResultToggles: {
    showNames: boolean;
    showResponses: boolean;
    showResults: boolean;
  };
};

const resultsGridSlice = createSlice({
  name: 'resultsGridData',
  initialState: initialState(),
  reducers: {
    toggleNames(state, action: PayloadAction<boolean>) {
      state.liveResultToggles.showNames = action.payload;
      return state;
    },
    toggleResponses(state, action: PayloadAction<boolean>) {
      state.liveResultToggles.showResponses = action.payload;
      return state;
    },
    toggleResults(state, action: PayloadAction<boolean>) {
      state.liveResultToggles.showResults = action.payload;
      return state;
    },
    resetLiveResultToggles(state) {
      state.liveResultToggles.showResults = true;
      state.liveResultToggles.showResponses = true;
      state.liveResultToggles.showNames = true;

      return state;
    },
  },
});

const {
  toggleNames,
  toggleResponses,
  toggleResults,
  resetLiveResultToggles,
} = resultsGridSlice.actions;

export { toggleNames, toggleResponses, toggleResults, resetLiveResultToggles };

export default resultsGridSlice.reducer;
